@if (hasAlternateNames) {
  <div class="small mt-1">
    <a
      href="#"
      class="alternate-names"
      (click)="$event.preventDefault()"
      [ngbPopover]="alternateNamesPopover"
      popoverClass="phi"
      placement="bottom"
      container="body"
    ><strong>View Alternate Names&nbsp;&#9662;</strong></a>
  </div>
  <ng-template #alternateNamesPopover>
    <div class="row text-nowrap">
      <div class="col">
        <div><strong>FIRST</strong></div>
        @for (alternateFirstName of alternateFirstNames; track alternateFirstName) {
          <div>{{ alternateFirstName }}</div>
        } @empty {
          <app-blank-value-dash />
        }
      </div>
      <div class="col">
        <div><strong>LAST</strong></div>
        @for (alternateLastName of alternateLastNames; track alternateLastName) {
          <div>{{ alternateLastName }}</div>
        } @empty {
          <app-blank-value-dash />
        }
      </div>
    </div>
  </ng-template>
} @else if (showDashWhenEmpty) {
  <app-blank-value-dash />
}
